import { toast } from "sonner";

/**
 * Delete-with-undo helper. Executes the deletion optimistically but
 * shows a toast with an "Undo" button that runs `restoreFn` if pressed.
 *
 * @param {Object} options
 * @param {string} options.label - toast message, e.g. "Event deleted"
 * @param {Function} options.deleteFn - async () => void, actually performs the delete
 * @param {Function} options.restoreFn - async () => void, restores the item if undo pressed
 * @param {number} [options.duration=6000] - ms the toast stays visible
 * @param {string} [options.testid]
 */
export async function deleteWithUndo({ label, deleteFn, restoreFn, duration = 6000, testid }) {
  try {
    await deleteFn();
  } catch (e) {
    toast.error("Verwijderen mislukt");
    return;
  }
  toast(label, {
    duration,
    action: {
      label: "Ongedaan maken",
      onClick: async () => {
        try {
          await restoreFn();
          toast.success("Teruggezet");
        } catch {
          toast.error("Terugzetten lukte niet");
        }
      },
    },
    ...(testid ? { id: testid } : {}),
  });
}
